export const getTagName = (tagId, tags) => {
  const found = tags.find((tag) => tag.id == tagId);
  return found ? found.label : null;
};
